/**
 * Move focus to the cancelling control inside a just-opened dialog.
 *
 * This is one line of `querySelector` and it is the safety property of every destructive dialog in
 * the console: a dialog that opens with the cursor on "Delete" turns a reflexive Enter into the
 * thing the dialog exists to prevent. Radix focuses the first tabbable child by default, and the
 * first tabbable child is whichever button the layout happens to put first — so the rule has to be
 * stated, and once stated it may as well be somewhere a test can reach it.
 *
 * Returns whether it found something to focus, which is the part worth asserting: a dialog whose
 * cancel button lost its `data-cancel` marker fails silently and looks fine.
 */
export function focusCancel(root: ParentNode): boolean {
  const cancel = root.querySelector<HTMLElement>('[data-cancel]');
  cancel?.focus();
  return Boolean(cancel);
}
